import React, { useMemo, useEffect } from "react"
import { useDispatch } from "react-redux"
import { isEmpty, get } from "lodash"
import uuid from "uuid"

import { Panel } from "components/organisms/panel"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { NewsList } from "components/organisms/panel/newsList"
import { NikkeiPanel } from "components/organisms/panel/heatmap"
import MiddleChart from "components/molecules/chart/middleChart"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"
import { APIResponse } from "redux/apis/types"
import { ROUTE_LIST } from "config/const"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"
import { useLodingTrigger } from "components/actions/loading"

type NikkeiAverageTemplateType = {
  data: APIResponse.Res
  detailsData: APIResponse.Res
  requestDetailsData: Function
}
export const NikkeiAverageTemplate: React.FC<
  NikkeiAverageTemplateType
> = props => {
  const canvasId = useMemo(() => {
    return uuid()
  }, [])
  const dispatch = useDispatch()
  useEffect(() => {
    const data = get(props.data, "ResultList")
    if (isEmpty(data)) return
    dispatch(changeSymbol(canvasId, data[0]))
  }, [props.data])
  const isSP = checkIsSp()
  const { loadingTrigger } = useLodingTrigger()

  return (
    <MainContainer className="right-thin-layout">
      <div className="contents-block nikkei-list-block">
        <NikkeiPanel
          data={props.data}
          onClick={(data: any) => {
            isSP
              ? dispatch(changeSpModalSymbol(data))
              : dispatch(changeSymbol(canvasId, data))
            props.requestDetailsData(data)
          }}
          selectedData={props.detailsData}
        />
      </div>
      <div className="contents-block  side-symbol-block">
        <div className="contents-nest-block">
          {!isSP && (
            <Panel className="panel-main-index" title="" nonePanelHeader={true}>
              <div>
                <MiddleChart id={canvasId} />
              </div>
              <InfoTable
                list={infoTableColumns.indicative}
                data={props.detailsData}
                className="table-striped table-index-detail"
                wrapperCls="index-detail-table-row"
              />
            </Panel>
          )}
          <NewsList
            route={ROUTE_LIST.DOMESTIC_AVERAGE}
            effect={loadingTrigger.loading}
            setEffect={loadingTrigger.setLoading}
          />
        </div>
      </div>
    </MainContainer>
  )
}
